import React, { useEffect, useState } from "react";
import { Save, Landmark, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminSettings() {
  const [form, setForm] = useState({ bank_account_holder: "", bank_name: "", bank_iban: "" });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setForm(r.data));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSaved(false);
    try {
      await api.put("/admin/settings", form);
      setSaved(true);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h1 className="font-display text-3xl mb-2">Ayarlar</h1>
      <p className="text-white/50 text-sm mb-8">
        Kayıt formunda öğrencilere gösterilen ödeme (havale/EFT) bilgilerini buradan güncelleyebilirsiniz.
      </p>

      <form onSubmit={save} className="max-w-lg bg-surface border border-white/10 p-8 space-y-6">
        <div className="flex items-center gap-2 text-gold text-sm uppercase tracking-widest mb-2">
          <Landmark className="w-4 h-4" /> Havale / EFT Bilgileri
        </div>

        {saved && (
          <div className="flex gap-2 items-center bg-gold/10 border border-gold-30 p-3 text-sm">
            <CheckCircle2 className="w-4 h-4 text-gold" /> Kaydedildi.
          </div>
        )}

        <label className="block">
          <span className="text-xs uppercase tracking-widest text-white/60 mb-2 inline-block">
            Hesap Sahibi
          </span>
          <input
            value={form.bank_account_holder}
            onChange={(e) => setForm((f) => ({ ...f, bank_account_holder: e.target.value }))}
            className="admin-input"
            required
          />
        </label>

        <label className="block">
          <span className="text-xs uppercase tracking-widest text-white/60 mb-2 inline-block">Banka</span>
          <input
            value={form.bank_name}
            onChange={(e) => setForm((f) => ({ ...f, bank_name: e.target.value }))}
            className="admin-input"
            required
          />
        </label>

        <label className="block">
          <span className="text-xs uppercase tracking-widest text-white/60 mb-2 inline-block">IBAN</span>
          <input
            value={form.bank_iban}
            onChange={(e) => setForm((f) => ({ ...f, bank_iban: e.target.value }))}
            className="admin-input font-mono"
            required
          />
        </label>

        <button type="submit" disabled={saving} className="btn-primary disabled:opacity-60">
          <Save className="w-4 h-4" /> {saving ? "Kaydediliyor..." : "Kaydet"}
        </button>
      </form>

      <style>{`.admin-input { width: 100%; background: #0F0F14; border: 1px solid rgba(255,255,255,0.08); padding: 0.6rem 0.9rem; color: white; font-family: 'Outfit', sans-serif; outline: none; font-size: 0.875rem; } .admin-input:focus { border-color: rgba(212,175,55,0.6); }`}</style>
    </div>
  );
}
